import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription as RxJsSubscription } from 'rxjs';
import { ActivityLogSearchParams } from '../../activity-log-search-params';
import { ActivityLog } from '../../activity-log';
import { Helpers } from '@app/shared';
@Component({
	selector: 'hpf-activity-log-list',
	templateUrl: './activity-log-list.component.html',
	styleUrls: [],
})
export class ActivityLogListComponent implements OnInit, OnDestroy {
	/** The filters */
	searchParams = new ActivityLogSearchParams(this.route.snapshot.queryParams);
	/** The search params subscription */
	private paramsSubscription: RxJsSubscription;
	/** Used to open or close filter drawer */
	filtersDrawer = false;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private location: Location
	) {}
	/** Init */
	ngOnInit() {
		// Update query string when params change
		this.paramsSubscription = this.searchParams.subscribe(() => {
			this.location.replaceState(
				'/activity-log',
				Helpers.toQueryString(this.searchParams.toObject())
			);
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.paramsSubscription.unsubscribe();
	}
	/** Called when the user select a row in the table */
	onSelect(item: ActivityLog) {
		this.router.navigateByUrl(`/activity-log/${item.getId()}`);
	}
	/** Called when the user click on create */
	onCreate() {
		this.router.navigate(['/activity-log/create']);
	}
}
